/*
  Aide: https://www.tektutorialshub.com/angular/angular-how-to-use-app-initializer/
  The Angular will execute the function provided by APP_INITIALIZER token when the application loads.
  If the function returns the promise, then the angular will wait until the promise is resolved.
  This will make it ideal place to perform some initialization logic before the application is initialized.
  (...)
 */
import { AppConfigService } from '../configuration/app.config.service';

export function InitServicesFactory(
  appConfigService: AppConfigService
) {
  return async (): Promise<any> => {
    console.log("Initialisation de l'application...");

    // Chargement de la configuration applicative par Promesse (asynchronisme), ce qui bloque le démarrage de l'appli tant qu'il n'y a pas de réponse.
    return appConfigService.loadConfiguration();
  };
}
